import {AfterViewInit, Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../base.component";
import {URLS} from "../app.urls";
import {Customer} from "../models/models.model";
import {Observable} from "rxjs";
import {map, startWith} from "rxjs/operators";
import {AuthService} from "../services/auth.service";
import {CustomerService, TicketService} from "../services/services.service";
import {MatDatepicker} from '@angular/material/datepicker';
import * as moment from 'moment';
import {Moment} from 'moment';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {Validators} from '@angular/forms';
import * as pdfmake from 'pdfmake/build/pdfmake';
import pdfFonts from "pdfmake/build/vfs_fonts";
import {ToastService} from '../services/toast.service';
import {MONTHS, PDF_BACKGROUND, PDF_LOGO} from "../app.constant";
import {formatDate, formatNumber} from "@angular/common";

pdfmake.vfs = pdfFonts.pdfMake.vfs;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMMM/YYYY', // this is the format showing on the input element
    monthYearLabel: 'MMMM/YYYY', // this is showing on the calendar
  },
};

@Component({
  selector: 'app-tickets-months',
  templateUrl: './tickets-months.component.html',
  styleUrls: ['./tickets-months.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})

export class TicketsMonthsComponent extends BaseComponent<any> implements OnInit, AfterViewInit {

  displayedColumns = ['customer', 'period', 'total', 'action', 'action2'];
  public filteredOptions: Observable<Customer[]>;
  public user: any;
  public customerList = new Array<Customer>();
  public displayedCertificate: any;
  public months = MONTHS;

  constructor(
    public injector: Injector,
    private authService: AuthService,
    private customerService: CustomerService,
    public toast: ToastService,
    private ticketService: TicketService,
  ) {
    super(injector, {
      endpoint: URLS.TICKET_PRODUCT,
      pagination: true,
      searchOnInit: false,
      keepFilters: true,
      retrieveOnInit: false,
      title: 'Tickets Mensais',
    });
  }

  ngOnInit(callback?: () => void) {
    this.user = this.authService.user;
    this.displayedCertificate = {
      costumer: '',
      residue: '',
      quantity: 0
    }
    super.ngOnInit(callback);
    this.getActiveCustomers().subscribe(success => {
      this.customerList = success;
    })
    setTimeout(() => {
      this.isClient();
    });
  }

  private isClient() {
    const user: any = this.authService.user;
    if (user.user_obj.users.length != 0) {
      this.formGroup.get('customer').setValue(user.user_obj.users[0]);
      this.formGroup.get('customer').disable();
    }
    this.service.addParameters(this.formGroup);
    this.searchButton();
  }

  getActiveCustomers() {
    this.customerService.clearParameter();
    this.customerService.addParameter('active', true);
    return this.customerService.getAll();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.user.user_obj.users) {
      this.filteredOptions = this.formGroup.controls.customer.valueChanges
        .pipe(
          startWith(''),
          map(value => value ? this._filter(value) : this.customerList.slice())
        );
    }
  }

  private _filter(name: string): Customer[] {
    let filterValue = name;
    if (typeof name === 'string') {
      filterValue = name.toLowerCase();
    }
    return this.customerList.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }


  createFormGroup(): void {
    this.formGroup = this.formBuilder.group({
      customer: [null, Validators.required],
      dt_inicial: [null],
      dt_final: [null, Validators.required],
    });
  }

  public searchButton(): void {
    this.service.clearParameter();
    this.service.addParameters(this.formGroup);
    if (!this.user.is_staff) {
      this.service.addParameter('customer', this.formGroup.controls.customer.value);
    }
    this.service.getFromListRoute<any>('destination_cert_list').subscribe(result => {
      this.dataSource.data = result;
    })
  }

  public clearField(formControl) {
    formControl.setValue('')
  }

  displayFn(customer?: Customer): string | undefined {
    return customer ? customer.name : undefined;
  }

  chosenMonthHandler(d: Moment, datepicker: MatDatepicker<Date>) {
    const curentPeriod = moment()
    const startOfMonth = d.clone().startOf('month').format('YYYY-MM-DD');
    const endOfMonth = d.clone().endOf('month').format('YYYY-MM-DD');

    if (d.clone().endOf('month').diff(curentPeriod) >= 0) {
      this.toast.error("Período ainda não fechado", "Data inválida");
    } else {
      this.formGroup.get('dt_inicial').setValue(startOfMonth)
      this.formGroup.get('dt_final').setValue(endOfMonth)
    }

    datepicker.close();
  }

  displayPeriod(d): string {
    return this.months[d];
    // return moment(d).locale('pt_br').format("MMMM/YYYY");
  }

  createTableBody(result) {
    let body = [];
    let total_weight = 0;
    body.push(
      [
        {text: 'Empresa', style: "header"},
        {text: 'Data', style: "header"},
        {text: 'Romaneio', style: "header"},
        {text: 'Ticket', style: "header"},
        {text: 'MTR', style: "header"},
        {text: 'Peso', style: "header"}
      ]);
    result.forEach(item => {
      const residue =
        [
          {text: `${item.customer_name}`, style: "body"},
          {text: `${formatDate(item.date_weight_final, "dd/MM/yyyy","pt_br")}`, style: "body"},
          {text: `${item.no_packing_list}`, style: "body"},
          {text: `${item.ticket_number || ""}`, style: "body"},
          {text: `${item.mtr || ""}`, style: "body"},
          {text: `${formatNumber(item.weight, "pt_br")} Kg`, style: "body"}
        ];
      total_weight += item.weight;
      body.push(residue);
    });
    const footer = []
    return body;
  }

  exportAsPDF(row) {
    this.ticketService.clearParameter();
    this.ticketService.addParameter('customer_id', row.ticket__customer_id)
    this.ticketService.addParameter('month', row.month)
    this.ticketService.addParameter('year', row.year)
    this.ticketService.getAll().subscribe(result => {
      const documentDefinition =
        {
          pageOrientation: 'landscape',
          content: [
            {
              image: 'data:image/jpeg;base64,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',
              width: 200
            },
            {text: "Tickets Emitidos", color: '#7e7e7e', fontSize: 20, margin: [0, 0, 0, 15], bold: true},
            {
              table: {
                headerRows: 1,
                widths: ['40%', '10%', "10%", "10%", "10%", "20%"],
                body: this.createTableBody(result)
              }
            }
          ],
          styles: {
            header: {
              fontSize: 11,
              bold: true,
              fillColor: '#9bba58',
              color: '#fff',
              margin: [5, 5, 5, 5]
            },
            body: {
              fontSize: 11,
              bold: false,
              fillColor: '#edebe0',
              color: '#585858',
              margin: [5, 5, 5, 5]
            },
            text: {
              color: '#585858',
              fontSize: 12,
              margin: [0, 10, 0, 0],
              lineHeight: 2,
            }
          },
          defaultStyle: {
            alignment: 'center'
          }
        };
      pdfmake.createPdf(documentDefinition).download(`${this.displayPeriod(row.month-1).toUpperCase()}.pdf`);

    })
  }

  createTableBodyTikets(result) {
    var body = [];
    body.push(
        [
          {text: 'MTR', style: "header"},
          {text: 'DATA', style: "header"},
          {text: 'MATERIAL', style: "header"},
          {text: 'QUANTIDADE', style: "header"},
          {text: 'VALOR UNIT', style: "header"},
          {text: 'VALOR TOTAL', style: "header"},
        ]);
    var totalValue = 0;
    result.forEach(item => {
      const residue =
          [
            {text: `${item.mtr || " - "}`, style: "body"},
            {text: `${formatDate(item.date_collect, "dd/MM/yyyy","pt_br")}`, style: "body"},
            {text: `${item.residue_name  }`, style: "body"},
            {text: `${formatNumber(item.weight, 'pt_br')} Kg`, style: "body"},
            {text: `${formatNumber(item.value_unit, 'pt_br')}`, style: "body"},
            {text: `${formatNumber(item.value, 'pt_br')} `, style: "body"},
          ];
      totalValue += item.value
      body.push(residue);
    });
    body.push(
        [
          {text: `-`, style: "body"},
          {text: `-`, style: "body"},
          {text: `-`, style: "body"},
          {text: `-`, style: "body"},
          {text: `TOTAL`, style: "header"},
          {text: `${formatNumber(totalValue, 'pt_br')} `, style: "header"},
        ]
    )
    return body;
  }

  exportTicketsAsPDF(row) {
    this.service.clearParameter();
    this.service.addParameter('customer', row.ticket__customer_id)
    this.service.addParameter('month', row.month)
    this.service.addParameter('year', row.year)
    this.service.getFromListRoute<any>('tickets_by_client').subscribe(result => {
      const documentDefinition =
          {
            pageOrientation: 'landscape',
            content: [
              {
                image: PDF_LOGO,
                width: 100
              },
              {
                columns: [
                  {
                    text: result[0].customer_name || "", color: '#7E7E7E', fontSize: 14, bold: true
                  },
                  { text: ` ${row.month < 10  ? '0'+ row.month : row.month}/${row.year}`, color: 'gray', fontSize: 14},
                ],
              },

              {
                table: {
                  headerRows: 1,
                  widths: ['*', '*', '*', '*', '*', '*'],
                  body: this.createTableBodyTikets(result)
                },
                layout: {
                  hLineColor: 'white',
                  vLineColor: 'white'
                }
              },
            ],
            pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
              return currentNode.startPosition.top >= 650;
            },
            styles: {
              header: {
                fontSize: 11,
                bold: true,
                fillColor: '#9bba58',
                color: '#fff',
                margin: [5, 5, 5, 5]
              },
              body: {
                fontSize: 11,
                bold: false,
                fillColor: '#edebe0',
                color: '#585858',
                margin: [5, 5, 5, 5]
              },
              text: {
                color: '#585858',
                fontSize: 12,
                alignment: 'center',
                margin: [0, 10, 0, 0],
                lineHeight: 2,
              }
            },
            defaultStyle: {
              alignment: 'center'
            }
          };
      pdfmake.createPdf(documentDefinition).download(`${row.ticket__customer__name}_${this.displayPeriod(row.month-1).toUpperCase()}.pdf`);
    })
  }
}
